import { Component, OnInit, ViewChild } from "@angular/core";
import { FilterConstants } from "src/app/constants/filterConstants";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { TokenService } from "src/app/core/services/token.service";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { PatronesWltpService } from "../patrones-wltp.service";
import { Options } from "src/app/shared/filters/models/filters.model";
import { ScreenConstants } from "src/app/constants/screenId.constants";
import { CommonService } from "src/app/core/services/common.service";

@Component({
  selector: "app-list-wltp",
  templateUrl: "./list-wltp.component.html",
  styleUrls: ["./list-wltp.component.sass"],
})
export class ListWltpComponent implements OnInit {
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  public filtersTable;
  public filtersSearch = "";

  public listItems: any[];
  filterList = FilterConstants.patronWltp;
  tableList = TableConstants.patronWltp;
  routing = RoutingConstants.patronWltp;
  options: Options = TableConstants.NotShowCreateDeleteAndArrowUpDown;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;
  filtersTableJSON;
  listaResultados: any[];
  showFilterButtons: boolean = false;

  showTableFilter = false;

  constructor(
    private patronesWltpService: PatronesWltpService,
    private filtersTableStateService: FiltersTableStateService,
    private toastrAlertService: ToastrAlertService,
    private tokenService: TokenService,
    private commonService: CommonService
  ) {
    this.options.style = { "min-width": "850px" };
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      this.routing.id,
      ScreenConstants.admDatos.wltp
    );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.filtersSearch = this.filtersTableStateService.composeFiltersInTable(
      this.filterList
    );
  }

  ngOnInit(): void {
    this.loadInitialList();
  }

  loadInitialList(): void {
    let filters = this.commonService.concatFilters(
      this.filtersTable,
      this.filtersSearch
    );
    this.patronesWltpService.getPatronWltpLista(filters).subscribe(
      (data) => {
        this.listItems = data["content"];
        this.numPages = data["totalPages"] == 0 ? 1 : data["totalPages"];
        this.numElements = data["numberOfElements"];
        this.totalElements = data["totalElements"];
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje
            ? err.error.mensaje
            : "Error al cargar lista de datos"
        );
      }
    );
    if (this.listaResultados?.length === 0) {
      this.toastrAlertService.toastrFail(
        "No se han encontrado registros con esos datos"
      );
    }
  }

  filterSearch(value: string) {
    if (value) {
      this.filtersSearch = value;
      this.loadInitialList();
    } else {
      this.toastrAlertService.toastrFail("Introduce algún termino de búsqueda");
    }
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = value.filterTableString;
    this.loadInitialList();
  }

  buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersValuesSearch = [];
        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParams();
        this.filtersTableStateService.setPageState(0);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.loadInitialList();
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          this.showFilterButtons = false;
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }
  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }

  public showFilters(type: string) {
    if (type === "normal") {
      this.showTableFilter = true;
    }
    this.showFilterButtons = true;
  }
}
